module.exports = __webpack_public_path__ + "static/img/16.f34729c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/16.png
// module id = vadY
// module chunks = 0